import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const NotFoundPage = () => {
  return (
    <div
      style={{
        backgroundColor: '#141414',
        color: '#fff',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Large 404 in Background */}
      <h1
        style={{
          position: 'absolute',
          fontSize: '40vw',
          fontWeight: 'bold',
          color: 'rgba(255, 255, 255, 0.05)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1
        }}
      >
        404
      </h1>

      {/* Foreground Content */}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <h1 className="fw-bold mb-3">404</h1>
        <h2 className="fw-bold mb-3">Nothing to see here</h2>
        <p className="mb-4">
          The page you are trying to open does not exist. You may have
          mistyped the address, or the page has been moved to another URL.
          If you think this is an error, please contact support.
        </p>
        <Link to="/">
          <Button variant="primary" size="lg" style={{ padding: '10px 20px', backgroundColor: '#c4ef17', color: '#000', border: 'none' }}>
            Take me back to home page
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
